import React from 'react';
import { Button } from 'react-bootstrap';
import { ArrowLeft } from 'lucide-react';

function DarkHeader({ 
    title = "HiveMind Network", 
    subtitle = "Your command center for growth and approvals.",
    showBackButton = true,
    onBack,
    backButtonText = "Back to Dashboard"
}) {
    return (
        <header className="page-header" style={{ padding: '0 2rem', paddingTop: '2rem' }}>
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                    {showBackButton && (
                        <>
                            <Button 
                                variant="outline-light" 
                                className="btn-pill mobile-back-btn theme-button" 
                                onClick={onBack}
                            >
                                Back
                            </Button>
                            <div className="desktop-nav-buttons d-flex align-items-center gap-3">
                                <Button 
                                    variant="outline-light" 
                                    className="btn-pill theme-button" 
                                    onClick={onBack}
                                    style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                                >
                                    <ArrowLeft size={16} />
                                    {backButtonText}
                                </Button>
                            </div>
                        </>
                    )}
                </div>
                <h1 className="page-title">
                    {title}
                    <span className="header-badge">
                        Pro
                    </span>
                </h1>
                {subtitle && (
                    <p className="page-subtitle">
                        {subtitle}
                    </p>
                )}
            </div>
        </header>
    );
}

export default DarkHeader;

